import { InjectionToken } from '@angular/core';

export interface AssigneeDropdownConfig {
  api: string;
  placeholder: string;
  filters: { key: string; value: string }[];
}

/** One type of a configured resource-type filter and the lookup it opens. Labels are translation keys. */
export interface ResourceTypeOptionConfig {
  value: string;
  label: string;
  api: string;
  placeholder: string;
  filters?: { key: string; value: string }[];
}

/** Replaces the built-in resource types (department, group, ...) with other types, e.g. invoice payees. */
export interface ResourceTypeConfig {
  typeLabel: string;
  typePlaceholder: string;
  assigneeLabel: string;
  assigneePlaceholder: string;
  /** false shows a single select instead of the multi-select (default true). */
  multiple?: boolean;
  types: ResourceTypeOptionConfig[];
}

/**
 * Provide it on a page to give that page's `resourceType` filters other types
 * (e.g. invoice payees) without changing the filter dropdown.
 */
export const RESOURCE_TYPE_CONFIG = new InjectionToken<ResourceTypeConfig>(
  'RESOURCE_TYPE_CONFIG'
);
